module.exports = __webpack_public_path__ + "img/create-quiz-btb.9b4d1bd1.svg";